/* Grainova click tracking (Claude, Round 19, 9 Oct 2026). Loaded with defer from layout/theme.liquid.
   Sends one "gv2_click" custom event per tap on the shopping controls added in Rounds 15-18, so their use can be
   measured. Events go to Shopify's Customer events (Settings > Customer events > a custom pixel can forward them to
   Google Analytics or Meta) and, if the store ever adds Google Tag Manager, to window.dataLayer as well.
   Event data: { action, label, page } - no personal data. Nothing here changes how any control behaves. */
(function () {
  if (window.gvTrack) return;
  var RULES = [
    ['[data-gv2-step-dir]', 'card_stepper', function (el) { return el.getAttribute('data-gv2-step-dir') === '1' ? 'plus' : 'minus'; }],
    ['.gv2-card__add', 'card_add'],
    ['[data-gv2-cbar-open]', 'cart_bar_open'],
    ['[data-gv2-coupon-remove], [data-gv2-cs-remove]', 'coupon_remove', function (el) { return el.getAttribute('data-gv2-coupon-remove') || el.getAttribute('data-gv2-cs-remove'); }],
    ['[data-gv2-apply-code]', 'coupon_apply_toggle', function (el) { return el.getAttribute('data-gv2-apply-code'); }],
    ['[data-gv2-cs-apply]', 'coupon_apply', function (el) { return el.getAttribute('data-gv2-cs-apply'); }],
    ['[data-gv2-cs-open]', 'coupons_open'],
    ['.gv2-boxnudge', 'box_nudge'],
    ['.gv2-ch__box', 'collection_box_pill'],
    ['.gv2-rshop__add', 'recipe_add', function (el) { return el.getAttribute('aria-label'); }],
    ['[data-gv2-dir]', 'row_arrow', function (el) { return el.getAttribute('data-gv2-dir') === '1' ? 'next' : 'prev'; }],
    ['[data-gv2-rowdots] button', 'row_dot'],
    ['a[href*="wa.me"], a[href*="api.whatsapp.com"]', 'whatsapp'],
    ['a[href*="build-your-box"], a[href$="#build-a-box"]', 'build_box_link'],
    ['[name="checkout"], a[href*="/checkout"]', 'checkout']
  ];
  function send(action, label) {
    var data = { action: action, label: label ? String(label).slice(0, 100) : '', page: location.pathname };
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('gv2_click', data); } catch (e) { /* ignore */ }
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'gv2_click', gv2_action: data.action, gv2_label: data.label, gv2_page: data.page }); } catch (e) { /* ignore */ }
  }
  window.gvTrack = send;
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    for (var i = 0; i < RULES.length; i++) {
      var el = e.target.closest(RULES[i][0]);
      if (el) { send(RULES[i][1], RULES[i][2] ? RULES[i][2](el) : (el.textContent || '').trim().replace(/\s+/g, ' ')); return; }
    }
  }, { capture: true, passive: true });
})();
